'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _lib = require('mc/lib');

require('./FilterField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentValue(eventOrValue) {
    if (eventOrValue) {
        var target = eventOrValue.target;

        if (target) {
            if (target.type === 'checkbox') {
                return target.checked;
            }
            if (target.type === 'number') {
                return parseInt(target.value);
            }
            return target.value;
        }
    }
    return eventOrValue;
}

/**
 * Komponenta pro vykreslení filtrovacího pole.
 */

var FilterField = function (_PureComponent) {
    (0, _inherits3.default)(FilterField, _PureComponent);

    function FilterField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FilterField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilterField.__proto__ || (0, _getPrototypeOf2.default)(FilterField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (eventOrValue) {
            // Předpokládáme jednu následující komponentu uvnitř pole:
            // 1) Nativní komponenta, jako např. <input>, které v onChange vrací SyntheticEvent.
            // 2) Vlastní komponenta, která v onChange vrací přímo novou hodnotu namísto event.
            var _this$props = _this.props,
                name = _this$props.name,
                onChange = _this$props.onChange;

            onChange(name, getComponentValue(eventOrValue));
        }, _this.handleRemove = function () {
            var _this$props2 = _this.props,
                name = _this$props2.name,
                onRemove = _this$props2.onRemove;

            onRemove(name);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FilterField, [{
        key: 'renderComponent',
        value: function renderComponent() {
            var _props = this.props,
                value = _props.value,
                Component = _props.component,
                componentProps = _props.componentProps;

            return _react2.default.createElement(Component, (0, _extends3.default)({}, componentProps, {
                value: value,
                onChange: this.handleChange }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                label = _props2.label,
                checkbox = _props2.checkbox;

            return _react2.default.createElement(
                'div',
                { className: 'filter-field' },
                _react2.default.createElement(
                    'div',
                    { className: 'filter-field-label' },
                    _react2.default.createElement(
                        _reactstrap.Label,
                        { checked: checkbox },
                        checkbox && this.renderComponent(),
                        checkbox && ' ',
                        _react2.default.createElement(
                            'span',
                            null,
                            label
                        )
                    )
                ),
                !checkbox && _react2.default.createElement(
                    'div',
                    { className: 'filter-field-component' },
                    this.renderComponent()
                ),
                _react2.default.createElement(
                    _reactstrap.Button,
                    { className: 'filter-field-remove-button',
                        color: 'action',
                        onClick: this.handleRemove },
                    _react2.default.createElement(_lib.Icon, { icon: 'times-circle-o' })
                )
            );
        }
    }]);
    return FilterField;
}(_react.PureComponent);

FilterField.propTypes = {
    name: _propTypes2.default.any.isRequired, // Jméno pole.
    label: _propTypes2.default.any.isRequired, // Popisek pole.
    value: _propTypes2.default.any, // Hodnota pole.
    checkbox: _propTypes2.default.bool, // Zda komponentu pole renderovat jako checkbox, tzn. nalevo od popisku.
    component: _propTypes2.default.func.isRequired, // Komponenta uvnitř pole. Očekává se, že bude podporovat properties "value" a "onChange".
    componentProps: _propTypes2.default.object.isRequired, // Properties předané komponentě uvnitř pole.
    onChange: _propTypes2.default.func.isRequired, // Callback volaný při změně hodnoty pole.
    onRemove: _propTypes2.default.func.isRequired // Callback volaný při odebrání pole.
};
exports.default = FilterField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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